module.exports = ".forgot-password-content {\n  margin-top: 170px; }\n"